import getCarrier from './getCarrier';
import { toGb } from './formatters';

export const sortByEffectiveDate = (subs) => {
  subs = [].concat(subs);

  subs.sort((a, b) => {
    if (!a.effective_date) {
      return 1;
    }

    if (a.effective_date < b.effective_date) {
      return 1;
    }
    if (a.effective_date > b.effective_date) {
      return -1;
    }

    return 0;
  });

  return subs;
};

export const expireTypeToBackendValue = (expiry_type) => {
  switch (expiry_type) {
    case 'mdn_change':
      return 'MDN change';
    case 'internal_movement':
      return 'Internal Movement';
    case 'nonpayment':
      return 'Non-payment';
    case 'port_out':
      return 'Port out';
    case 'cancel':
      return 'Cancellation';
    default:
      return expiry_type;
  }
};

export const viewSubUrl = (sub) => {
  if (sub) {
    if (sub.sprint_status) return `/subscriptions/${sub.id}/view`;
    if (sub.att_status) return `/att/subscriptions/${sub.id}/view`;
    if (sub.tracfone_status) return `/tracfone/subscriptions/${sub.id}/view`;
    if (sub.simo_status) return `/simo/subscriptions/${sub.id}/view`;
    if (sub.quick_status) return `/quick/subscriptions/${sub.id}/view`;

    return '#';
  }
  return '#';
};

export const viewSubUrlFromCarrier = (id, carrier) => {
  if (carrier === 'sprint') {
    return `/subscriptions/${id}/view`;
  }
  if (carrier === 'att') {
    return `/att/subscriptions/${id}/view`;
  }
  if (carrier === 'tracfone') {
    return `/tracfone/subscriptions/${id}/view`;
  }
  if (carrier === 'simo') {
    return `/simo/subscriptions/${id}/view`;
  }
  if (carrier === 'quick') {
    return `/quick/subscriptions/${id}/view`;
  }
  return '#';
};

export const sortSubs = (subscriptions, ordering) => {
  if (!ordering) {
    return subscriptions;
  }

  const comparator = (a, b) => {
    const isDesc = ordering[0] === '-';
    const orderKey = isDesc ? ordering.slice(1) : ordering;
    if (orderKey === 'status') {
      const getOrderStatusKey = (sub) => {
        return `${getCarrier(sub)}_status`;
      };
      if (a[getOrderStatusKey(a)] < b[getOrderStatusKey(b)]) {
        return isDesc ? -1 : 1;
      }
      if (a[getOrderStatusKey(a)] > b[getOrderStatusKey(b)]) {
        return isDesc ? 1 : -1;
      }
    }

    if (a[orderKey] < b[orderKey]) {
      return isDesc ? 1 : -1;
    }
    if (a[orderKey] > b[orderKey]) {
      return isDesc ? -1 : 1;
    }

    return 0;
  };

  let subs = [].concat(subscriptions);
  subs.sort(comparator);

  return subs;
};

export const getSubIdWithCarrierFromLineitem = (item) => {
  let carrier = '';
  let id = null;

  if (item.subscription) {
    carrier = 'sprint';
    id = item.subscription;
  } else if (item.att_subscription) {
    carrier = 'att';
    id = item.att_subscription;
  } else if (item.tracfone_subscription) {
    carrier = 'tracfone';
    id = item.tracfone_subscription;
  } else if (item.simo_subscription) {
    carrier = 'simo';
    id = item.simo_subscription;
  } else if (item.quick_subscription) {
    carrier = 'quick';
    id = item.quick_subscription;
  }

  return {
    id,
    carrier,
  };
};

export const getUniqSubs = (subs) => {
  let uniqSubs = [];

  for (let sub of subs) {
    if (
      !uniqSubs.find(
        (uniqSub) => uniqSub.id === sub.id && uniqSub.carrier === sub.carrier,
      )
    ) {
      uniqSubs.push(sub);
    }
  }

  return uniqSubs;
};

export const getCarrierApiPrefix = (carrier) => {
  switch (carrier) {
    case 'att':
    case 'simo':
    case 'quick':
    case 'tracfone': {
      return `/${carrier}`;
    }

    default: {
      return '';
    }
  }
};

export const getCarrierPrefix = (carrier) => {
  switch (carrier) {
    case 'att':
    case 'simo':
    case 'quick':
    case 'tracfone': {
      return `${carrier}_`;
    }

    default: {
      return '';
    }
  }
};

export const prettifyCarrier = (carrier) => {
  switch (carrier) {
    case 'att':
      return 'AT&T';
    case 'tracfone': {
      return 'TracFone';
    }
    case 'sprint': {
      return 'Sprint';
    }
    case 'simo': {
      return 'Simo';
    }
    case 'quick': {
      return 'Quick';
    }
    default: {
      return '';
    }
  }
};

export const getSubStatus = (sub) => {
  if (!sub) {
    return '';
  }

  if (sub.tracfone_status) {
    return sub.tracfone_status;
  } else if (sub.att_status) {
    return sub.att_status;
  } else if (sub.sprint_status) {
    return sub.sprint_status;
  } else if (sub.simo_status) {
    return sub.simo_status;
  } else if (sub.quick_status) {
    return sub.quick_status;
  }

  return '';
};

export const getPrettyPlanCarrier = (planCarrier) => {
  if (!planCarrier) {
    return '';
  }

  if (planCarrier === 'tsp' || planCarrier === 'pwg') {
    return planCarrier.toUpperCase();
  }

  if (planCarrier === 'att') {
    return 'AT&T';
  }

  return planCarrier;
};

export const needToShowPlanCarrier = (sub, plan_carrier) =>
  getCarrier(sub) === 'att' && ['pwg', 'tsp', 'att'].includes(plan_carrier);

export const isExpiredInLessThan30Days = (sub) => {
  if (!sub) {
    return false;
  }

  const subStatus = getSubStatus(sub);
  if (subStatus !== 'expired') {
    return false;
  }

  const today = new Date();

  const expireDate = new Date(sub.expiry_date);
  expireDate.setDate(expireDate.getDate() + 30); // add 30 days

  return expireDate > today;
};

export const simoStatuses = [
  'new',
  'acknowledged',
  'active',
  'suspended',
  'expired',
];
export const simoDeviceStatuses = ['active', 'suspended', 'expired'];

export const sortSimoExpiryTypes = (array) => {
  if (!array || !array.length) {
    return [];
  }

  let resultArray = [...array];
  resultArray.sort((a, b) => {
    if (a[1] > b[1]) {
      return 1;
    }
    if (a[1] < b[1]) {
      return -1;
    }
    return 0;
  });

  return resultArray;
};

export const quickRenderPlan = (plan, showPrice) => {
  if (!plan) {
    return null;
  }
  let planName = showPrice ? `${plan.name} - ${plan.price}` : plan.name;

  if (plan) {
    return `${planName} | Data available: ${plan.data_available}MB | Type: ${plan.plan_type && plan.plan_type.toString()}`;
  } else {
    return null;
  }
};

export const simoRenderPlan = (plan, showPrice) => {
  if (!plan) {
    return null;
  }
  let planName = showPrice
    ? `${plan.display_name} - ${plan.price}`
    : plan.display_name;

  const planDataInGb = toGb(plan.data_available);

  return `${planName} | Data available: ${planDataInGb}GB`;
};

export const formatPlanOptions = (plans, showPrice) => {
  if (showPrice) {
    return plans.map((plan) => [plan.id, `${plan.name} - $${plan.price}`]);
  } else {
    return plans.map((plan) => [plan.id, plan.name]);
  }
};
